import { getAiUsageCount, updateAiUsageCount } from "./api";

/**
 * 指定されたサービス名に対して、今月のAI使用回数を取得する非同期関数です。
 *
 * @param service - AIサービス名（例: "openai", "azure-openai", "anthropic" など）
 * @returns Promise<number> 今月の指定サービスのAI使用回数
 */
export const getUsedAiUsageCount = async (service: string): Promise<number> => {
    const now = new Date();
    const month = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}`;

    try {
        const count = await getAiUsageCount(service, month);
        return count;
    } catch (error) {
        await updateAiUsageCount(service, month, 0);
        // 1回だけリトライ
        try {
            const count = await getAiUsageCount(service, month);
            return count;
        } catch (retryError) {
            throw retryError;
        }
    }
};